import { ProductDetailViewEvent } from '@/usecases/event-bus-for-third-party/events/product-detail'
import { DataLayerService } from '@/vendor/gtm/data-layer'
import { viewItemEventFactory } from '@/vendor/gtm/events/ga4/view-item'

/**
 * GP標準: GA4推奨フォーマットの view_item イベント
 *
 * @see https://github.com/Everforth/growthpalette-front/issues/8754
 * @see https://github.com/Everforth/growthpalette-front/issues/8606
 */
export function handleProductDetailViewEventForGA4(event: ProductDetailViewEvent): void {
  const dataLayerService = new DataLayerService()
  const viewItemEvent = viewItemEventFactory.createFromProductDetailViewEvent(event)
  dataLayerService.push(viewItemEvent)
}
